import React from 'react';

import IMPLANTES from '../../../../assets/swiss-medical-center/centro_implantes.jpg';
import Image from '../../../Commons/Image/Image';

import styles from './OdontoImplantes.module.scss';

const OdontoImplantes = () => {
  return (
    <div className={styles.odonto_implantes}>
      <h3>Clínica de Implantes</h3>
      <p>
        <strong className={styles.odonto_implantes__redText}>Dirección: </strong>Av. Pueyrredón
        1416, 3º piso (1118), Capital Federal
      </p>
      <p>
        <strong className={styles.odonto_implantes__redText}>Turnos: </strong>0810-333-8876
      </p>
      <Image
        src={IMPLANTES}
        alt='Clínica de Implantes'
        title='Clínica de Implantes'
        classes={styles.odonto_implantes__image}
      />
      <p>
        En nuestro Centro especializado en implantes dentales, atendido por experimentados
        profesionales, se realizan tratamientos de acuerdo a protocolos internacionales, utilizando
        materiales de última generación y con la mejor tecnología existente.
      </p>
      <p>
        <strong>Especialidades</strong>
      </p>
      <ul>
        <li>Implantes dentales</li>
        <li>Cirugía odontológica</li>
        <li>Prótesis sobre implantes</li>
        <li>Cirugía maxilofacial</li>
        <li>Prótesis dentales</li>
      </ul>
      <p>
        <strong className={styles.odonto_implantes__redText}>Días y horarios de atención</strong>
      </p>
      <p>Lunes a Viernes | 08 hs. a 20 hs.</p>
      <p>Sábados | 08 hs. a 14 hs.</p>
    </div>
  );
};

export default OdontoImplantes;
